function getTimezoneList() {
    const timezoneList = moment.tz
        .names()
        // NOTE: Filter not needed timezone which not represent any geographic regions
        .filter(
            zone =>
                !zone.startsWith("Etc/") &&
                !zone.startsWith("GMT") &&
                !["Universal", "UCT"].includes(zone)
        )
        .map(zone => {
            const offset = moment.tz.zone(zone).utcOffset(moment());
            const offsetHours = Math.abs(Math.floor(offset / 60));
            const offsetMinutes = Math.abs(offset % 60);
            const sign = offset >= 0 ? "-" : "+";

            const timezone = `(UTC${sign}${offsetHours
                .toString()
                .padStart(2, "0")}:${offsetMinutes
                .toString()
                .padStart(2, "0")}) ${zone}`;

            return {
                text: timezone.replaceAll("_", " "),
                value: zone,
                offset: offset
            };
        });

    // NOTE: sort by timezone time
    timezoneList.sort((a, b) => {
        if (a.offset !== b.offset) {
            return b.offset - a.offset;
        } else {
            return b.value.localeCompare(a.value);
        }
    });

    return timezoneList;
}

export default getTimezoneList;
